import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { DisplayLanguageList } from '../../services/admin-display-language';

const endpoint = `displaylanguages`;

export const useGetAllAdminDisplayLanguage = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<DisplayLanguageList>
  >(`${endpoint}?${params}`, GetAllAsync, options);

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};
